// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import PropTypes from 'prop-types';

import { MrInputSelect, formValidators } from '@ion/components';

const { validateRequired } = formValidators;

export const IntegrationSelect = ({ formState, validateField, availableIntegrations, onChange }) => {
  if (availableIntegrations.length === 0) {
    return null;
  }

  const integrationsSelectOptions = availableIntegrations.map(integration => {
    const hasRevisions = integration.playbooks.length > 0;
    return {
      text: hasRevisions ? integration.name : `${integration.name} (No revisions available)`,
      value: integration.id,
      disabled: !hasRevisions,
    };
  });

  return (
    <MrInputSelect
      options={integrationsSelectOptions}
      onBlur={validateField}
      validators={[validateRequired()]}
      name="integration"
      label="Select Integration"
      placeholder="Select..."
      value={formState.integration.value || ''}
      onChange={onChange}
      errorMsg={formState.integration.errorMsg}
      menuPosition="fixed"
      testId="integrationSelect"
      required
    />
  );
};

IntegrationSelect.propTypes = {
  formState: PropTypes.object.isRequired,
  validateField: PropTypes.func.isRequired,
  availableIntegrations: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
};
